class CTMobileMenu {
  constructor(element) {
    this.element = element;
    this.drawer = element.querySelector('.ct-mobile-menu__drawer');
    this.activePanel = null;
    this.activeTrigger = null;
    this.mediaQuery = window.matchMedia('(min-width: 990px)');

    this.bindEvents();
  }

  bindEvents() {
    this.element.addEventListener('toggle', () => {
      document.body.classList.toggle(
        'ct-mobile-menu-open',
        this.element.open
      );

      if (!this.element.open) {
        this.closeSubmenu(false);
      }
    });

    this.element.addEventListener('click', (event) => {
      const submenuTrigger = event.target.closest(
        '[data-ct-submenu-open]'
      );

      if (
        submenuTrigger &&
        this.element.contains(submenuTrigger)
      ) {
        event.preventDefault();
        this.openSubmenu(submenuTrigger);
        return;
      }

      const backButton = event.target.closest(
        '[data-ct-submenu-back]'
      );

      if (backButton && this.element.contains(backButton)) {
        event.preventDefault();
        this.closeSubmenu();
        return;
      }

      const closeButton = event.target.closest(
        '[data-ct-mobile-menu-close]'
      );

      if (closeButton && this.element.contains(closeButton)) {
        event.preventDefault();
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.element.open) return;

      if (this.activePanel) {
        this.closeSubmenu();
      } else {
        this.close();
      }
    });

    this.mediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        this.close();
      }
    });
  }

  openSubmenu(trigger) {
    const panelId = trigger.dataset.ctSubmenuOpen;

    if (!panelId) return;

    const panel = this.element.querySelector(
      `[data-ct-submenu-panel="${panelId}"]`
    );

    if (!panel) return;

    this.closeSubmenu(false);

    this.activePanel = panel;
    this.activeTrigger = trigger;

    trigger.setAttribute('aria-expanded', 'true');

    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');

    if (this.drawer) {
      this.drawer.classList.add(
        'ct-mobile-menu__drawer--submenu-open'
      );
    }

    const backButton = panel.querySelector(
      '[data-ct-submenu-back]'
    );

    window.requestAnimationFrame(() => {
      backButton?.focus();
    });
  }

  closeSubmenu(returnFocus = true) {
    if (!this.activePanel) return;

    this.activePanel.hidden = true;
    this.activePanel.setAttribute('aria-hidden', 'true');

    if (this.activeTrigger) {
      this.activeTrigger.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    if (this.drawer) {
      this.drawer.classList.remove(
        'ct-mobile-menu__drawer--submenu-open'
      );
    }

    const previousTrigger = this.activeTrigger;

    this.activePanel = null;
    this.activeTrigger = null;

    if (returnFocus && previousTrigger) {
      previousTrigger.focus();
    }
  }

  close() {
    this.closeSubmenu(false);

    this.element.removeAttribute('open');
    document.body.classList.remove('ct-mobile-menu-open');

    const trigger = this.element.querySelector(
      '.ct-mobile-menu__trigger'
    );

    trigger?.focus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-ct-mobile-menu]')
    .forEach((element) => {
      new CTMobileMenu(element);
    });
});